module.exports = __webpack_public_path__ + "static/media/HamburgerIcon.c987bde0.svg";